import {
  request,
  SSOService,
  websiteRequest,
  prefRequest,
  conv,
  resumeParser,
  ServiceCandidate,
  register,
  websiteCareerpageRequest,
  requestSuggestion,
  KeynodeService,
  trainingService,
} from "../utils/request.js";
import axios from "axios";
import { getAccess, getRefreshToken, setLocalTokens, setRefreshToken, setToken } from "./helpers.js";
const qs = require("qs");
import store from "../store";


export const getNewAccessToken = async () => {
	const authDataRefreshToken = getRefreshToken();

	let payload = qs.stringify({
		grant_type: "refresh_token",
		client_id: "vue-test-app",
		refresh_token: authDataRefreshToken,
	});

	try {
		const response = await axios({
			method: "post",
			// url: "https://auth.hire3x.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
			url: "https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
			data: payload,
			headers: {
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
			},
		});
		setToken(response.data.access_token);
		setRefreshToken(response.data.refresh_token);
    setLocalTokens()
		store.commit("setCandAccess", true);
    store.commit("setLoginStatus", true);
		if (response.status == 400) {
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		if (axios.isCancel(error) || ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)) {
			console.warn("Token refresh request cancelled");
			return;
		}
		store.dispatch("userVUEX/LogOut");
	}
};

// Refresh Google access token using the backend endpoint
export const refreshGoogleToken = async () => {
	const refreshToken = getRefreshToken();

	try {
		const response = await ServiceCandidate.post("/can/auth/google-refresh/", {
			refresh_token: refreshToken
		});
		if (response.data.type === "Success") {
			const tokens = response.data.data;
      setToken(tokens.id_token);
      setLocalTokens()
      store.commit("setCandAccess", true);
      store.commit("setLoginStatus", true);
			// Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
		} else {
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		if (axios.isCancel(error) || ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)) {
			return;
		}
		store.dispatch("userVUEX/LogOut");
	}
};

// Unified function to refresh access token based on login type
export const refreshAccessToken = async () => {
	const loginData = getAccess('loginData');
	if (loginData && loginData.logged_in === "google") {
		// User logged in via Google - use Google refresh endpoint
		await refreshGoogleToken();
	} else {
		// User logged in via Keycloak - use existing refresh flow
		await getNewAccessToken();
	}
};

export const getSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "get",
    params: data,
  });
};

export const postSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "post",
    data,
  });
};

export const deleteSearchHistoryDashboard = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/",
    method: "delete",
    data,
  });
};

// Anonymous Search History APIs
export const getAnonymousSearchHistory = (params) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "get",
    params,
  });
};

export const postAnonymousSearchHistory = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "post",
    data,
  });
};

export const deleteAnonymousSearchHistory = (data) => {
  return ServiceCandidate({
    url: "/user/search-history/anonymous/",
    method: "delete",
    data,
  });
};

/**
 * Migration API: Sync guest search history to authenticated user account
 * Called immediately after successful login to transfer anonymous browsing history
 */
export const migrateGuestSearchHistory = async (guestUUID) => {
  return ServiceCandidate({
    url: "/user/search-history/migrate/",
    method: "post",
    data: { uuid: guestUUID },
  });
};

export const getCourseSuggestion = (data) => {
  return trainingService({
    url: `marketplace/top-search/`,
    method: "get",
    params: data,
  });
};

export const contactUs = (data) => {
  return request({
    url: `/contact-us/`,
    method: "post",
    data,
  });
};
export const userLogin = (data) => {
  return KeynodeService({
    url: "token",
    method: "post",
    headers: {
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
    },
    data,
  });
};
export const keyCloakLogin = (token) => {
  // return axios.get("https://keynode.simplifycv.com/user-access/",{
  return axios.get("https://keynode.hire3x.com/user-access/", {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const converter = (data) => {
  return conv({
    // url: "htmltopdf",
    url: "rep/resume-clinic-download/",
    method: "POST",
    responseType: "blob",
    data,
  });
};
export const parseResume = (data) => {
  return resumeParser({
    url: `christ-parser/`,
    method: "post",
    data,
  });
};

export const getPreference = () => {
  return prefRequest({
    url: `user-preference/`,
    method: "get",
  });
};

export const getjobDetails = () => {
  return request({
    url: `careers/jobs/`,
    method: "get",
  });
};


export const sendMail = (data) => {
  return websiteRequest({
    url: `contact-us/`,
    method: "post",
    data,
  });
};

export const getJobs = () => {
  return websiteCareerpageRequest({
    url: `careers/jobs/`,
    method: "get",
    params: {
      version: "v2",
    },
  });
};
export const subscribeNewLetter = (data) => {
  return websiteRequest({
    url: `newsletter/`,
    method: "post",
    data,
  });
};
export const sendOtp = (data) => {
  return register({
    url: `user/send-otp/`,
    method: "post",
    data,
  });
};
export const checkCandOtp = (data) => {
  return register({
    url: `user/check-otp/`,
    method: "get",
    params: data,
  });
};
export const resetPassword = (data) => {
  return register({
    url: `user/reset-password/`,
    method: "put",
    data,
  });
};
export const registerCan = (data) => {
  return register({
    url: `can/register/`,
    method: "post",
    data,
  });
};
export const checkAndSendOTP = (data) => {
  return register({
    url: `can/check-user/`,
    method: "post",
    data,
  });
};
export const emailCheck = (data) => {
  return register({
    url: `can/login/?email=${data}`,
    method: "get",
  });
};
export const googleLinkedInLogin = (data, token) => {
  return ServiceCandidate({
    url: `/can/auth/`,
    method: "post",
    data,
    headers: { Authorization: `Bearer ${token}` },
  });
};
export const resumeClinic = (data) => {
  return resumeParser({
    url: `resume-clinic/`,
    method: "post",
    data,
  });
};

export const suggestedJobs = (data) => {
  return ServiceCandidate({
    url: `job/job-search/`,
    method: "post",
    data,
  });
};

export const getRedirect = (data) => {
  return request({
    url: `marketing-mail/`,
    method: "put",
    data
  });
};
export const getTrendingTags = (data) => {
  return ServiceCandidate({
    url: `job/global-trending/`,
    method: "get",
    params: data,
  });
};

export const getSearchSuggestions = (data) => {
  return ServiceCandidate({
    url: "/user/search-suggetion/",
    method: "get",
    params: data,
  });
};

export const getSkillSuggestions = (data) => {
  return requestSuggestion({
    url: "/suggest-skills/",
    method: "get",
    params: data,
  });
};

export const getSuggestion = (data) => {
  return requestSuggestion({
    url: "/get-skills/",
    method: "get",
    params: {
      searchQuery: data,
    },
  });
};

export const userLogOut = (data, headers) => {
  return SSOService({
    url: `auth/realms/hire3x-dev/protocol/openid-connect/logout`,
    method: "post",
    headers: headers,
    data,
  });
};

export const getProfileCompletion = () => {
  return ServiceCandidate({
    url: "user/profile-progress/",
    method: "get",
  });
};

export const postPanelResult = (data) => {
	return ServiceCandidate({
		url: "/pan/panel-application-results/",
		method: "post",
		data,
		//   headers: { userID: "613ae10c-7056-4868-b51b-c19b6977c7c" }
	});
};

export const getCvsDetails = () => {
	return ServiceCandidate({
		method: "get",
		url: "/pan/application-status/",
	});
};
